import { Snackbar, Fade, Slide, Grow, Box, IconButton, Typography, Alert } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'

const SlideTransition = (props) => {
  return <Slide {...props} direction="down" />
}

const GrowTransition = (props) => {
  return <Grow {...props} />
}

const CreateErrorSnackBar = ({
  createErrorSnackbar,
  setCreateErrorSnackbar,
  message,
  autoHideDuration,
  TransitionComponent = Fade,
  handleAction,
  canUndo,
  actionText = 'Undo',
  buttonText = 'Button', // Button is for testing/display at component page only, can change depends on usage
  icon,
  status,
  sx,
}) => {
  const handleClose = () => {
    setCreateErrorSnackbar(false)
  }

  const action = (
    <Box height="100%" mb={0.5}>
      {canUndo ? (
        <Typography sx={{ cursor: 'pointer', color: 'alternate.main' }} onClick={handleAction}>
          {actionText}
        </Typography>
      ) : (
        <IconButton size="small" aria-label="close" color="white" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  )

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={createErrorSnackbar}
      onClose={handleClose}
      TransitionComponent={
        TransitionComponent === 'slide'
          ? SlideTransition
          : TransitionComponent === 'grow'
          ? GrowTransition
          : Fade
      }
      autoHideDuration={autoHideDuration}
    >
      <Alert
        sx={{ display: 'flex', alignItems: 'center', ...sx }}
        color={status === 'error' ? 'error' : 'dark-text'}
        variant="filled"
        icon={
          icon ? (
            icon
          ) : status === 'error' ? (
            <ErrorIcon sx={{ fontSize: 20, color: 'white' }} />
          ) : status === 'success' ? (
            <CheckCircleIcon sx={{ fontSize: 20, color: 'positive.main' }} />
          ) : (
            false
          )
        }
        action={action}
      >
        <Typography color="white.main">{message}</Typography>
      </Alert>
    </Snackbar>
  )
}

export default CreateErrorSnackBar
